import React from 'react';
import PropTypes from 'prop-types';
import './common.css';

const CommonTable = ({
  // defaults to [] so a caller that omits data renders the empty state
  // instead of throwing on data.length
  data = [],
  columns,
  className = ''
}) => {
  return (
    <div className={`common-table-basic-container ${className}`}>
      <div className="table-responsive">
        <table className="common-table-basic">
          <thead>
            <tr>
              {columns.map((column) => (
                <th
                  key={column.accessor || column.header}
                  style={{
                    width: column.width || 'auto',
                    textAlign: column.align || 'left'
                  }}
                >
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((row, rowIndex) => (
                <tr key={row[columns[0].accessor] ?? rowIndex}>
                  {columns.map((column) => (
                    <td
                      key={column.accessor || column.header}
                      style={{ textAlign: column.align || 'left' }}
                    >
                      {column.render
                        ? column.render(row[column.accessor], row, rowIndex)
                        : row[column.accessor]
                      }
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} className="no-data-basic">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

CommonTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.node,
      accessor: PropTypes.string,
      align: PropTypes.string,
      width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      render: PropTypes.func,
    }),
  ).isRequired,
  className: PropTypes.string,
};

export default CommonTable;
